import React, { Suspense } from "react";
import { router } from "./router/router";
import store from "@redux/store";
import DarkModeProvider from "@context/darkMode/darkModeProvider";

import { ToastContainer } from "react-toastify";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import LoadingScreen from "./router/loadingScreen/loadingScreen";
// Importa il supporto per tooltip mobile
import "./utils/mobileTooltips";

// PointsModal lazy-loaded: it pulls in framer-motion + lucide + mp3 refs, none of
// which are needed for first paint on /, /home/ripeti, /home/maturita-esame, /home/profilo.
const PointsModal = React.lazy(() => import("./components/gamification/PointsModal"));

// NOTA: QAWebSocketService non viene importato qui — il listener deve essere
// inizializzato quando effettivamente si carica un documento (route document/chat
// lo importano lazy dove serve), non all'avvio globale dell'app.

const getApp = () => {
  const toastProps = {
    style: { zIndex: 99999999 },
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    newestOnTop: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    limit: 3,
  };

  if (process.env.NODE_ENV === "development") {
    return (
      <Provider store={store}>
        <HelmetProvider>
          <DarkModeProvider>
            <ToastContainer {...toastProps} />
            <PointsModal />
            <RouterProvider router={router} fallbackElement={<LoadingScreen />} />
          </DarkModeProvider>
        </HelmetProvider>
      </Provider>
    );
  }

  return (
    <Provider store={store}>
      <HelmetProvider>
        <DarkModeProvider>
          <ToastContainer {...toastProps} />
          <Suspense fallback={null}>
            <PointsModal />
          </Suspense>
          <RouterProvider router={router} fallbackElement={<LoadingScreen />} />
        </DarkModeProvider>
      </HelmetProvider>
    </Provider>
  );
};

export default getApp;
